import React from "react";
import { isMobile } from 'react-device-detect';
import { TSubservice } from "../../../../../Interfaces/constants";


const Subservices = ({picture, icon, title, description}: TSubservice) => {

  const normalizedContent = Array.isArray(description) ? description.join(", ") : description;

  return (
    <div className={isMobile ? 'pt-5 px-2' : 'py-5 px-2'}>
      <div className='d-flex'>
      <img src={picture?.src} alt={picture?.alt} className='services-picture me-3'/>
      <div className='ms-2'>
        <div className='d-flex mb-2'>
          <img src={icon?.src} alt={icon?.alt} className='services-icon me-2'/>
          <h3 className='mb-0'>{title}</h3>
        </div>
        <p className='services-text'  dangerouslySetInnerHTML={{ __html: normalizedContent }} />
      </div>
    </div>
    </div>
  )
}

export default Subservices;
